/*
 * @message: 入口配置
 * @Author: cjc
 * @since: 2019-11-26 12:10:14
 * @lastTime     : 2019-12-26 12:24:17
 * @LastAuthor   : cjc
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'

import 'lib-flexible/flexible'
import '@/assets/styles/commen.scss'

import vueSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(vueSwiper)

Vue.config.productionTip = false
Vue.prototype.$http = axios

// api调取地址
axios.defaults.baseURL = 'http://gongting.hkleyougame.com'
axios.get('/', {
  params: {
    game_key: 'gongting'
  }
}).then((response) => {
  Vue.prototype.$cdnPath = response.data.data.cdn_server
})

// rem自适应方案
window.onload = function () {
  let docEl = this.document.documentElement
  let width = docEl.getBoundingClientRect().width
  docEl.style.fontSize = width / 10 + 'px'
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App),
  mounted () {
    document.dispatchEvent(new Event('render-event'))
  }
  // components: { App },
  // template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js